import i18next from 'i18next';

i18next.addResources('en', 'NewPeriodModal', {
  title: 'Record new period',
  periodID: 'ID',
  number: 'No.',
  year: 'Year',
  startDate: 'Start date',
  endDate: 'End date',
  note: 'Notes',
  week: 'Week',
  confirm: 'Confirm'
});
